import { render, staticRenderFns } from "./shengyaceping.vue?vue&type=template&id=4ea10e46&scoped=true"
import script from "./shengyaceping.vue?vue&type=script&lang=js"
export * from "./shengyaceping.vue?vue&type=script&lang=js"
import style0 from "./shengyaceping.vue?vue&type=style&index=0&id=4ea10e46&prod&lang=css"
import style1 from "./shengyaceping.vue?vue&type=style&index=1&id=4ea10e46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea10e46",
  null
  
)

export default component.exports